import { gql, useQuery } from "@apollo/client";
import { captureException } from "@sentry/react";

import { AUTH_ID } from "constants";
import WalletBalances from "./WalletBalances";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";

export default () => {
  // Fetch data
  const GET_WALLET_BALANCES = gql`
    query GetWalletBalances {
      walletBalances {
        user {
          balance
          cash_balance
        }
        pendingBalance
      }
    }
  `;

  const sn = "s" + localStorage.getItem("sn");

  const BALANCE_UPDATES_SUBSCRIPTION = gql`
    subscription onBalanceUpdate($userId: uuid!) {
      ${sn} {
        users_by_pk(id: $userId) {
          balance
        }
      }
    }
  `;

  const { subscribeToMore, data, error } = useQuery(GET_WALLET_BALANCES, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching wallet balances", error);
    captureException(error);
  }

  const userId = localStorage.getItem(AUTH_ID);

  //console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="255px" />
        </LoadingBox>
      )}
      {data && (
        <WalletBalances
          data={data}
          subscribeToUpdates={() =>
            subscribeToMore({
              document: BALANCE_UPDATES_SUBSCRIPTION,
              variables: { userId },
              updateQuery: (prev, { subscriptionData }) => {
                if (!subscriptionData.data) return prev;

                if (!subscriptionData.data[sn].users_by_pk) {
                  return prev;
                }

                return {
                  walletBalances: {
                    user: {
                      balance: subscriptionData.data[sn].users_by_pk.balance,
                      cash_balance: data.walletBalances.user.cash_balance,
                      __typename: "User",
                    },
                    pendingBalance: data.walletBalances.pendingBalance,
                  },
                };
              },
            })
          }
        />
      )}
    </>
  );
};
